import { connect } from 'react-redux';
import { getSongs } from 'services/store/songs/actions';
import { SongsStore } from 'services/store/songs';
import { ITag } from 'services/api/entities';
import SongListItem from './SongListItem';

const mapStateToProps = ({
  songs,
  tags,
}: {
  songs: SongsStore;
  // @ts-ignore
  tags: TagStore;
}) => ({ tagStore: tags, page: songs.page });

// @ts-ignore
const mapDispatchToProps = (dispatch) => ({
  getSongs: (params: {
    page: number;
    selectedTags?: {
      [key: string]: ITag;
    };
    appliedFilters?: {
      [key: string]: ITag;
    };
  }) => {
    const { page, selectedTags, appliedFilters } = params;
    // @ts-ignore
    dispatch(getSongs(page, selectedTags, appliedFilters));
  },
});

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(SongListItem);
